import React, { useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import Papa from "papaparse";
import Modal from "@mui/material/Modal";
import BasicTitle from "../components/title";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import { useDropzone } from "react-dropzone";
import Loader from "./loader";
import ErrorModal from "./error_modal";
import ModalUpgrade from "./modal_upgrade";

import { DataGrid } from "@mui/x-data-grid";

import Api from "../libs/api";
import Storage from "../libs/storage";
import Helper from "../libs/helper";
import { useImpersonation } from "../global/impersonation";
import { DownloadAddUsers } from "../utils/downloadCsv";
import { CircularProgress } from "@mui/material";
import ModalSpecialPlanOffer from "./modal_special_plan_offer";

const ModalCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 688px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
`;

const ModalClose = styled.img`
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`;

const ModalView = styled.div`
    margin-bottom: 16px;
    max-height: 70vh;
`;

const ModalLineView = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 24px;
`;

const ModalFooter = styled.div`
    display: flex;
    width: 100%;
    align-items: right;
    justify-content: flex-end;
`;

const Clear = styled.div`
    clear: both;
`;

export default function AddUser({
    type,
    title,
    open,
    close,
    banks,
    categories,
    projects,
    getUsers,
    activeUsersCount,
    maxUsersAllowed,
    enablePayments,
    availablePlans,
    currentPlanName,
    showToastMessage,
    setRefetchProfile,
    companyCnpj = "",
    acceptTermsOfUse = false,
}) {
    let api = Api();
    let storage = Storage();
    let helper = Helper();
    const { impersonateCompanyId } = useImpersonation();

    const [step, setStep] = useState(0);
    const [loading, setLoading] = useState(false);

    const [name, setName] = useState("");
    const [bank, setBank] = useState();
    const [hiring, setHiring] = useState(null);
    const [email, setEmail] = useState("");
    const [agency, setAgency] = useState(null);
    const [profile, setProfile] = useState(null);
    const [account, setAccount] = useState(null);
    const [cpf, setCpf] = useState(null);
    const [pixType, setPixType] = useState(null);
    const [pixKey, setPixKey] = useState(null);
    const [invalidEmails, setInvalidEmails] = useState([]);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [errorModalMessage, setErrorModalMessage] = useState("");
    const [localUpgradeModalOpen, setLocalUpgradeModalOpen] = useState(false);
    const [openUpgradeSpecialModal, setOpenUpgradeSpecialModal] = useState(false);
    const [localSuggestedPlan, setLocalSuggestedPlan] = useState(null);

    function showErrorModal(message) {
        setErrorModalMessage(message);
        setErrorModalOpen(true);
    }
    const [users, setUsers] = useState([]);
    const [rows, setRows] = useState([
        {
            id: 0,
            name: "---",
            email: "---",
            profile: "---",
        },
    ]);

    const columns = [
        {
            field: "name",
            headerName: "Nome",
            width: 250,
            renderCell: (params) => (
                <span
                    style={{
                        color: params.row.isInvalid ? "#DE6061" : "#000",
                        fontWeight: params.row.isInvalid ? "500" : "200",
                    }}
                >
                    {params.value}
                </span>
            ),
        },
        {
            field: "email",
            headerName: "E-mail",
            width: 300,
            renderCell: (params) => (
                <span
                    style={{
                        color: params.row.isInvalid ? "#DE6061" : "#000",
                        fontWeight: params.row.isInvalid ? "500" : "200",
                    }}
                >
                    {params.value}
                </span>
            ),
        },
        {
            field: "profile",
            headerName: "Perfil",
            width: 180,
            renderCell: (params) => (
                <span
                    style={{
                        color: params.row.isInvalid ? "#DE6061" : "#000",
                        fontWeight: params.row.isInvalid ? "500" : "200",
                    }}
                >
                    {params.value}
                </span>
            ),
        },
    ];

    const [selectedProjects, setSelectedProjects] = useState([]);
    const [inputValueProject, setInputValueProject] = useState("");

    const activeProjects = projects.filter((project) => !project.disabled);

    const getProjectName = (id) => {
        const project = activeProjects.find((project) => project.id === id);
        return project ? project.name : "";
    };

    const handleClearSelectedProjects = (event) => {
        setSelectedProjects([]);
    };

    const handleInputChangeProject = (event, newInputValue) => {
        setInputValueProject(newInputValue);
    };

    const handleChangeProjects = (event, newValue) => {
        if (newValue && newValue[newValue.length - 1]?.id === "allProjects") {
            const allProjects = activeProjects.map((project) => project.id);
            setSelectedProjects(allProjects);
        } else {
            setSelectedProjects(newValue.map((project) => project.id));
        }
    };

    const handleRemoveProject = (projectToRemove) => {
        setSelectedProjects((prevSelected) =>
            prevSelected.filter((project) => project !== projectToRemove.id)
        );
    };

    const selectedProjectObjects = activeProjects.filter((project) =>
        selectedProjects.includes(project.id)
    );

    const [selectedCategories, setSelectedCategories] = useState([]);
    const [inputValueCategory, setInputValueCategory] = useState("");

    const activeCategories = categories.filter(
        (category) => !category.disabled
    );

    const getCategoryName = (id) => {
        const category = activeCategories.find(
            (category) => category.id === id
        );
        return category ? category.name : "";
    };

    const handleClearSelectedCategories = (event) => {
        setSelectedCategories([]);
    };

    const handleInputChangeCategory = (event, newInputValue) => {
        setInputValueCategory(newInputValue);
    };

    const handleChangeCategories = (event, newValue) => {
        if (newValue && newValue[newValue.length - 1]?.id === "allCategories") {
            const allCategories = activeCategories.map(
                (category) => category.id
            );
            setSelectedCategories(allCategories);
        } else {
            setSelectedCategories(newValue.map((category) => category.id));
        }
    };

    const handleRemoveCategory = (categoryToRemove) => {
        setSelectedCategories((prevSelected) =>
            prevSelected.filter((category) => category !== categoryToRemove.id)
        );
    };

    const selectedCategoryObjects = activeCategories.filter((categorie) =>
        selectedCategories.includes(categorie.id)
    );

    const [errorMessage, setErrorMessage] = useState("");
    const [nextLoading, setNextLoading] = useState(false);

    const handleNextStep = async () => {
        try {
            if (step === 1) {
                setLoading(true);
                const data = await storage.getItem("data");

                const hiddenCategories =
                    selectedCategories.length > 0
                        ? categories
                              .filter((categorie) =>
                                  selectedCategories.includes(categorie.id)
                              )
                              .map((categorie) => categorie.id)
                        : selectedCategories;

                const hiddenProjects =
                    selectedProjects.length > 0
                        ? projects
                              .filter((project) =>
                                  selectedProjects.includes(project.id)
                              )
                              .map((project) => project.id)
                        : selectedProjects;

                await api.addUsers(
                    data.token,
                    users,
                    hiddenCategories,
                    hiddenProjects,
                    impersonateCompanyId
                );
                setLoading(false);
                reset();
                close();
                getUsers("all", "all");
            } else if (step === 0) {
                if (type === "many" && enablePayments) {
                    const usersToAdd = users.length;
                    const totalAfterAdd = activeUsersCount + usersToAdd;

                    // Verificar se excede o limite
                    if (totalAfterAdd > maxUsersAllowed) {
                        // Se estiver adicionando mais de 99 usuários, abre o modal especial
                        if (totalAfterAdd > 99) {
                            setOpenUpgradeSpecialModal(true);
                            reset();
                            close();
                            return;
                        }

                        // Encontrar o plano sugerido
                        const suggested = availablePlans
                            .filter((p) => p.maxUsers >= totalAfterAdd && !p.isCurrent)
                            .sort((a, b) => a.maxUsers - b.maxUsers)[0];

                        if (suggested) {
                            setLocalSuggestedPlan(suggested);
                            setLocalUpgradeModalOpen(true);
                            reset();
                            close();
                        } else {
                            showErrorModal(
                                "Não há planos disponíveis que suportem mais usuários."
                            );
                        }
                        return;
                    }
                }

                setNextLoading(true);
                setStep(step + 1);
                setNextLoading(false);
            } else {
                setNextLoading(true);
                setStep(step + 1);
                setNextLoading(false);
            }
        } catch (error) {
            showErrorModal(
                "Não foi possível cadastrar o usuário. Verifique os dados e tente novamente."
            );
        }
    };

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    // const pix_type = {
    //   cpf: 1,
    //   cnpj: 1,
    //   email: 2,
    //   telefone: 3,
    //   chave: 4,
    // };

    const _user_type = ["Usuário", "Administrador", "Proprietário"];
    const [fileFormatOk, setFileFormatOk] = useState(false);
    const [fileName, setFileName] = useState("");
    const [csvStructureError, setCsvStructureError] = useState(false);

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            if (file && file.name.endsWith(".csv")) {
                setFileFormatOk(true);
            } else {
                setFileFormatOk(false);
            }
            setFileName(file.name);
            const reader = new FileReader();

            reader.onabort = () => console.log("file reading was aborted");
            reader.onerror = () => console.log("file reading has failed");
            reader.onload = (e) => {
                const _users = [];
                const text = e.target.result;
                Papa.parse(text, {
                    header: false,
                    skipEmptyLines: true,
                    complete: (results) => {
                        const data = results.data.slice(2); // Ignora as duas primeiras linhas
                        for (const user of data) {
                            // Ignora linhas com células vazias
                            if (!user[0] || !user[1]) continue;
                            const newUser = {
                                name: user[0],
                                email: user[1].trim(),
                                profile: 0,
                                hiring: null,
                                cpf: null,
                                bank: null,
                                agency: null,
                                account: null,
                                pixType: null,
                                pixKey: null,
                            };
                            _users.push(newUser);
                        }
                        setUsers(_users);
                        if (file.name.endsWith(".csv") && _users.length === 0) {
                            setCsvStructureError(true);
                        } else {
                            setCsvStructureError(false);
                        }
                    },
                });
            };
            reader.readAsText(file);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    });

    const reset = () => {
        setStep(0);
        setName(null);
        setBank(null);
        setHiring(null);
        setEmail(null);
        setAgency(null);
        setProfile(null);
        setAccount(null);
        setCpf(null);
        setPixType(null);
        setPixKey(null);
        setUsers([]);
        setSelectedProjects([]);
        setSelectedCategories([]);
        setLoading(false);
        setCsvStructureError(false);
    };

    useEffect(() => {
        if (users.length > 0) {
            let _rows = [];
            for (let index = 0; index < users.length; index++) {
                const _user = users[index];
                const emailTrimmed = _user.email.trim();
                const nameTrimmed = _user.name.trim();

                const isEmailInvalid = invalidEmails.includes(emailTrimmed);
                const isNameInvalid = nameTrimmed.length < 3;

                _rows.push({
                    id: index + 1,
                    name: _user.name,
                    email: emailTrimmed,
                    profile: _user_type[_user.profile],
                    isInvalid: isEmailInvalid || isNameInvalid,
                });
            }
            setRows(_rows);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users, invalidEmails]);

    useEffect(() => {
        if (name && email) {
            setUsers([
                {
                    name,
                    bank: bank ? bank : null,
                    hiring,
                    email,
                    agency: null,
                    profile: 0,
                    account: null,
                    cpf: null,
                    pixType: pixType ? pixType : null,
                    pixKey: null,
                },
            ]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        name,
        bank,
        hiring,
        email,
        agency,
        profile,
        account,
        cpf,
        pixType,
        pixKey,
    ]);

    const handleDownloadAddUsers = () => {
        DownloadAddUsers();
    };

    useEffect(() => setFileFormatOk(false), []);

    const [isValidating, setIsValidating] = useState(false);
    const [isCheckingEmail, setIsCheckingEmail] = useState(false);

    const validateEmails = async (users) => {
        const data = await storage.getItem("data");
        const token = data.token;
        setIsValidating(true); // começa a validação
        const invalids = [];

        for (const user of users) {
            const email = user.email.trim();

            const invalidFormat =
                email.includes(" ") || !helper.validEmail(email);
            const response = await api.checkEmail(token, email);
            const emailAlreadyExists = response?.data?.checkEmail === true;

            if (invalidFormat || emailAlreadyExists) {
                invalids.push(email);
            }
        }

        setInvalidEmails(invalids);

        if (invalids.length > 0) {
            setErrorMessage(
                "Não foi possível realizar o cadastro dos usuários sinalizados. Garanta que o email esteja correto e disponível."
            );
            setIsValidating(false);
            return true;
        } else {
            setErrorMessage("");
            setIsValidating(false);
            return false;
        }
    };

    const [hasEmailError, setHasEmailError] = useState(false);
    const isBatchMode = type === "many";

    useEffect(() => {
        const runValidation = async () => {
            if (isBatchMode && users.length > 0 && fileFormatOk) {
                const hasError = await validateEmails(users);
                setHasEmailError(hasError);
            } else if (isBatchMode) {
                setHasEmailError(false);
                setErrorMessage("");
            }
        };

        runValidation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users, fileFormatOk, isBatchMode]);

    return (
        <>
            <Modal
                open={open}
                onClose={() => {
                    reset();
                    close();
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ zIndex: 1000 }}
            >
                <ModalCenter style={{ width: 1280, maxWidth: "60%" }}>
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={() => {
                            reset();
                            close();
                            setErrorMessage("");
                            setNextLoading(false);
                        }}
                    />
                    {loading && <Loader inside={true} />}
                    <BasicTitle title={title} margin={24} />
                    <Clear />
                    <ModalView>
                        {step === 0 && (
                            <>
                                {type === "one" && (
                                    <>
                                        <ModalLineView>
                                            <TextField
                                                id="outlined-basic-1"
                                                label="Nome *"
                                                value={name}
                                                variant="outlined"
                                                style={{ width: "100%" }}
                                                onChange={(event) => {
                                                    setName(event.target.value);
                                                }}
                                            />
                                        </ModalLineView>
                                        <ModalLineView>
                                            <TextField
                                                id="outlined-basic-2"
                                                label="Email *"
                                                value={email}
                                                variant="outlined"
                                                style={{ width: "100%" }}
                                                error={!!errorMessage}
                                                helperText={errorMessage}
                                                onChange={async (event) => {
                                                    const cleanedEmail =
                                                        removeAccents(
                                                            event.target.value.trim()
                                                        );
                                                    setEmail(cleanedEmail);

                                                    if (
                                                        !helper.validEmail(
                                                            cleanedEmail
                                                        )
                                                    ) {
                                                        setErrorMessage(
                                                            "Email inválido ou indisponível"
                                                        );
                                                        return;
                                                    }

                                                    setIsCheckingEmail(true);
                                                    setErrorMessage("");

                                                    try {
                                                        const data =
                                                            await storage.getItem(
                                                                "data"
                                                            );
                                                        const token =
                                                            data.token;
                                                        const response =
                                                            await api.checkEmail(
                                                                token,
                                                                cleanedEmail
                                                            );
                                                        const emailExists =
                                                            response?.data
                                                                ?.checkEmail ===
                                                            true;

                                                        if (emailExists) {
                                                            setErrorMessage(
                                                                "Email inválido ou indisponível"
                                                            );
                                                        } else {
                                                            setErrorMessage("");
                                                        }
                                                    } catch (err) {
                                                        console.error(
                                                            "Erro ao verificar e-mail:",
                                                            err
                                                        );
                                                        setErrorMessage(
                                                            "Erro ao validar e-mail"
                                                        );
                                                    } finally {
                                                        setIsCheckingEmail(
                                                            false
                                                        );
                                                    }
                                                }}
                                            />
                                        </ModalLineView>
                                        <ModalLineView>
                                            <FormControl
                                                style={{
                                                    width: "100%",
                                                }}
                                            >
                                                <InputLabel>Perfil</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Perfil *"
                                                    value={0}
                                                    onChange={(event) => {
                                                        setProfile(
                                                            event.target.value
                                                        );
                                                    }}
                                                >
                                                    <MenuItem key={0} value={0}>
                                                        {_user_type[0]}
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </ModalLineView>
                                    </>
                                )}
                                {type === "many" && (
                                    <>
                                        <ModalLineView>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    width: "100%",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        marginBottom: 16,
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    USE O ARQUIVO ABAIXO COMO
                                                    MODELO, EDITE-O E REENVIE
                                                    PARA CADASTRAR OS DADOS
                                                    PESSOAIS DOS USUÁRIOS.
                                                    <br />
                                                    AO PREENCHER, SIGA AS
                                                    ORIENTAÇÕES DO CABEÇALHO DA
                                                    PLANILHA.
                                                </span>
                                                <div
                                                    style={{
                                                        flexDirection: "row",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <img
                                                        src="/img/download.png"
                                                        alt=""
                                                        width={24}
                                                        height={24}
                                                        style={{
                                                            marginRight: 8,
                                                        }}
                                                    />
                                                    <button
                                                        onClick={
                                                            handleDownloadAddUsers
                                                        }
                                                        style={{
                                                            fontWeight: 500,
                                                            color: "#419392",
                                                            cursor: "pointer",
                                                            border: "none",
                                                            background: "none",
                                                            fontSize: 14,
                                                            textDecoration:
                                                                "underline",
                                                        }}
                                                    >
                                                        CLIQUE AQUI E BAIXE A
                                                        PLANILHA-MODELO
                                                    </button>
                                                </div>
                                            </div>
                                        </ModalLineView>
                                        <div
                                            style={{
                                                width: "100%",
                                                padding: "34px 50px",
                                                background: isDragActive
                                                    ? "#FAFAFA"
                                                    : "#F6F6F6",
                                                border:
                                                    users.length > 0
                                                        ? "1px solid #9B9B9B"
                                                        : "1px dashed #9B9B9B",
                                                borderRadius: 8,
                                            }}
                                            {...getRootProps()}
                                        >
                                            <input {...getInputProps()} />
                                            {isDragActive ? (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: 8,
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                    }}
                                                >
                                                    <img
                                                        src="/img/upload.svg"
                                                        alt="ícone de upload"
                                                        width={24}
                                                        height={24}
                                                    />
                                                    <p
                                                        style={{
                                                            textAlign: "center",
                                                            fontWeight: "500",
                                                            fontSize: 12,
                                                            color: "#78737F",
                                                        }}
                                                    >
                                                        SOLTE PARA ADICIONAR O
                                                        ARQUIVO...
                                                    </p>
                                                </div>
                                            ) : csvStructureError ? (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 16,
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            gap: 8,
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <img
                                                            src="/img/alert.svg"
                                                            alt="ícone de alerta"
                                                            width={16}
                                                            height={16}
                                                        />
                                                        <p
                                                            style={{
                                                                fontWeight: "600",
                                                                fontSize: 12,
                                                                textTransform: "uppercase",
                                                                color: "#DE6061",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            MODELO INVÁLIDO. BAIXE O MODELO CORRETO E PREENCHA NOVAMENTE.
                                                        </p>
                                                    </div>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDownloadAddUsers();
                                                        }}
                                                        style={{
                                                            fontWeight: 600,
                                                            color: "#419392",
                                                            cursor: "pointer",
                                                            border: "none",
                                                            background: "none",
                                                            fontSize: 12,
                                                            textDecoration: "underline",
                                                            textTransform: "uppercase",
                                                        }}
                                                    >
                                                        CLIQUE AQUI E BAIXE A PLANILHA-MODELO
                                                    </button>
                                                </div>
                                            ) : users.length > 0 ? (
                                                fileFormatOk ? (
                                                    isValidating ? (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: 8,
                                                                alignItems:
                                                                    "center",
                                                                justifyContent:
                                                                    "center",
                                                            }}
                                                        >
                                                            <CircularProgress
                                                                size={16}
                                                            />
                                                            <p
                                                                style={{
                                                                    fontWeight:
                                                                        "600",
                                                                    fontSize: 12,
                                                                    textTransform:
                                                                        "uppercase",
                                                                    color: "#4B4455",
                                                                }}
                                                            >
                                                                VALIDANDO
                                                                E-MAILS, POR FAVOR AGUARDE...
                                                            </p>
                                                        </div>
                                                    ) : hasEmailError ? (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection:
                                                                    "column",
                                                                gap: 30,
                                                                alignItems:
                                                                    "center",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                    gap: 8,
                                                                    alignItems:
                                                                        "center",
                                                                }}
                                                            >
                                                                <img
                                                                    src="/img/alert.svg"
                                                                    alt="ícone de alerta"
                                                                    width={16}
                                                                    height={16}
                                                                />
                                                                <p
                                                                    style={{
                                                                        fontWeight:
                                                                            "600",
                                                                        fontSize: 12,
                                                                        textTransform:
                                                                            "uppercase",
                                                                        color: "#DE6061",
                                                                    }}
                                                                >
                                                                    {
                                                                        errorMessage
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: 8,
                                                                alignItems:
                                                                    "center",
                                                                justifyContent:
                                                                    "center",
                                                            }}
                                                        >
                                                            <img
                                                                src="/img/check.svg"
                                                                alt="ícone de Check"
                                                                width={16}
                                                                height={16}
                                                            />
                                                            <p
                                                                style={{
                                                                    fontWeight:
                                                                        "600",
                                                                    fontSize: 12,
                                                                    textTransform:
                                                                        "uppercase",
                                                                }}
                                                            >
                                                                {fileName}
                                                            </p>
                                                        </div>
                                                    )
                                                ) : (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection:
                                                                "column",
                                                            gap: 30,
                                                            alignItems:
                                                                "center",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: 8,
                                                                alignItems:
                                                                    "center",
                                                            }}
                                                        >
                                                            <img
                                                                src="/img/alert.svg"
                                                                alt="ícone de alerta"
                                                                width={16}
                                                                height={16}
                                                            />
                                                            <p
                                                                style={{
                                                                    fontWeight:
                                                                        "600",
                                                                    fontSize: 12,
                                                                    textTransform:
                                                                        "uppercase",
                                                                }}
                                                            >
                                                                {fileName}
                                                            </p>
                                                        </div>
                                                        <p
                                                            style={{
                                                                textAlign:
                                                                    "center",
                                                                fontWeight:
                                                                    "600",
                                                                textTransform:
                                                                    "uppercase",
                                                                color: "#DE6061",
                                                                fontSize: 10,
                                                            }}
                                                        >
                                                            o arquivo está em um
                                                            formato não
                                                            suportado, converta
                                                            para .csv e envie
                                                            novamente
                                                        </p>
                                                    </div>
                                                )
                                            ) : (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 26,
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            textAlign: "center",
                                                            textTransform:
                                                                "uppercase",
                                                            fontWeight: "500",
                                                            color: "#4B4455",
                                                        }}
                                                    >
                                                        após CONCLUIR O
                                                        PREENCHIMENTO DA
                                                        PLANILHA-MODELO,
                                                        arraste-a AQUI OU clique
                                                        nessa área para enviá-la
                                                    </p>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            gap: 8,
                                                            alignItems:
                                                                "center",
                                                        }}
                                                    >
                                                        <img
                                                            src="/img/atencao.svg"
                                                            alt="ícone de atenção"
                                                            width={16}
                                                            height={16}
                                                        />
                                                        <p
                                                            style={{
                                                                textAlign:
                                                                    "center",
                                                                textTransform:
                                                                    "uppercase",
                                                                fontWeight:
                                                                    "600",
                                                                fontSize: 12,
                                                                color: "#4B4455",
                                                            }}
                                                        >
                                                            só serão aceitos
                                                            arquivos no formato
                                                            .csv e emails
                                                            válidos
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {users.length > 0 && fileFormatOk && (
                                            <DataGrid
                                                style={{
                                                    marginTop: 24,
                                                    maxHeight: "40vh",
                                                }}
                                                rows={rows}
                                                columns={columns}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 5,
                                                        },
                                                    },
                                                }}
                                                pageSizeOptions={[
                                                    5, 10, 50, 100,
                                                ]}
                                                disableRowSelectionOnClick
                                            />
                                        )}
                                    </>
                                )}
                            </>
                        )}
                        {step === 1 && (
                            <>
                                <ModalLineView
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",

                                }}>
                                    <p>Selecione os centros de custos e categorias que deseja liberar para o usuário.</p>
                                <ModalLineView style={{ marginTop: 24 }}>
                                    <FormControl
                                        style={{
                                            width: "100%",
                                            marginRight: 24,
                                            display: "flex",
                                            alignItems: "flex-end",
                                        }}
                                    >
                                        <Box
                                            component="section"
                                            sx={{
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                justifyContent: "center",
                                                height: "250px",
                                                borderRadius: "5px",
                                                border: "1px solid lightgrey",
                                                transition: "border-color 0.3s",
                                                "&:hover": {
                                                    border: "2px solid #57C4C2",
                                                },
                                                "&:focus-within": {
                                                    border: "2px solid #57C4C2",
                                                },
                                            }}
                                        >
                                            <label
                                                style={{
                                                    padding: "0 10px",
                                                    marginTop: "-20px",
                                                    backgroundColor: "white",
                                                    fontSize: "12px",
                                                    color: "grey",
                                                    marginLeft: "10px",
                                                    fontWeight: "normal",
                                                }}
                                            >
                                                Centro de Custo
                                            </label>
                                            <Autocomplete
                                                sx={{
                                                    maxHeight: "230px",
                                                    minHeight: "230px",
                                                    overflowY: "auto",
                                                    width: "100%",
                                                    "& .MuiInputBase-root": {
                                                        backgroundColor:
                                                            "transparent",
                                                        border: "none",
                                                        boxShadow: "none",
                                                        "&:before": {
                                                            borderBottom:
                                                                "none !important",
                                                            backgroundColor:
                                                                "transparent !important",
                                                        },
                                                        "&:after": {
                                                            borderBottom:
                                                                "none !important",
                                                            backgroundColor:
                                                                "transparent !important",
                                                        },
                                                        "&:hover:before": {
                                                            borderBottom:
                                                                "none !important",
                                                            backgroundColor:
                                                                "transparent !important",
                                                        },
                                                    },
                                                }}
                                                multiple
                                                disableClearable
                                                id="autocomplete-projects"
                                                options={[
                                                    {
                                                        id: "allProjects",
                                                        name: "SELECIONAR TODOS",
                                                    },
                                                    ...activeProjects,
                                                ]}
                                                value={selectedProjectObjects}
                                                onChange={handleChangeProjects}
                                                inputValue={inputValueProject}
                                                onInputChange={
                                                    handleInputChangeProject
                                                }
                                                getOptionLabel={(project) => {
                                                    if (
                                                        project.id ===
                                                        "allProjects"
                                                    ) {
                                                        return (
                                                            <span
                                                                style={{
                                                                    color: "#419392",
                                                                    fontWeight: 500,
                                                                }}
                                                            >
                                                                {project.name}
                                                            </span>
                                                        );
                                                    } else {
                                                        return project.name;
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="filled"
                                                        sx={{
                                                            "& .MuiFilledInput-root":
                                                                {
                                                                    backgroundColor:
                                                                        "transparent",
                                                                    border: "none",
                                                                    boxShadow:
                                                                        "none",
                                                                    "&:before":
                                                                        {
                                                                            borderBottom:
                                                                                "none !important",
                                                                            backgroundColor:
                                                                                "transparent !important",
                                                                        },
                                                                    "&:after": {
                                                                        borderBottom:
                                                                            "none !important",
                                                                        backgroundColor:
                                                                            "transparent !important",
                                                                    },
                                                                    "&:hover:before":
                                                                        {
                                                                            borderBottom:
                                                                                "none !important",
                                                                            backgroundColor:
                                                                                "transparent !important",
                                                                        },
                                                                },
                                                        }}
                                                    />
                                                )}
                                                renderTags={(
                                                    value,
                                                    getTagProps
                                                ) =>
                                                    value.map(
                                                        (option, index) => (
                                                            <Chip
                                                                key={option.id}
                                                                label={getProjectName(
                                                                    option.id
                                                                )}
                                                                onDelete={() =>
                                                                    handleRemoveProject(
                                                                        option
                                                                    )
                                                                }
                                                                {...getTagProps(
                                                                    { index }
                                                                )}
                                                            />
                                                        )
                                                    )
                                                }
                                                freeSolo
                                                ListboxProps={{
                                                    style: {
                                                        overflowY: "auto",
                                                        maxHeight: "220px",
                                                    },
                                                }}
                                            />
                                        </Box>
                                        <Button
                                            sx={{
                                                width: 110,
                                                fontSize: 12,
                                                padding: "10px 0px",
                                            }}
                                            variant={"text"}
                                            color={"error"}
                                            onClick={
                                                handleClearSelectedProjects
                                            }
                                        >
                                            REMOVER TUDO
                                        </Button>
                                    </FormControl>
                                    <FormControl
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "flex-end",
                                        }}
                                    >
                                        <Box
                                            component="section"
                                            sx={{
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                justifyContent: "center",
                                                height: "250px",
                                                borderRadius: "5px",
                                                border: "1px solid lightgrey",
                                                transition: "border-color 0.3s",
                                                "&:hover": {
                                                    border: "2px solid #57C4C2",
                                                },
                                                "&:focus-within": {
                                                    border: "2px solid #57C4C2",
                                                },
                                            }}
                                        >
                                            <label
                                                style={{
                                                    padding: "0 10px",
                                                    marginTop: "-20px",
                                                    backgroundColor: "white",
                                                    fontSize: "12px",
                                                    color: "grey",
                                                    marginLeft: "10px",
                                                    fontWeight: "normal",
                                                }}
                                            >
                                                Categorias
                                            </label>
                                            <Autocomplete
                                                sx={{
                                                    maxHeight: "230px",
                                                    minHeight: "230px",
                                                    overflowY: "auto",
                                                    width: "100%",
                                                    "& .MuiInputBase-root": {
                                                        backgroundColor:
                                                            "transparent",
                                                        border: "none",
                                                        boxShadow: "none",
                                                        "&:before": {
                                                            borderBottom:
                                                                "none !important",
                                                            backgroundColor:
                                                                "transparent !important",
                                                        },
                                                        "&:after": {
                                                            borderBottom:
                                                                "none !important",
                                                            backgroundColor:
                                                                "transparent !important",
                                                        },
                                                        "&:hover:before": {
                                                            borderBottom:
                                                                "none !important",
                                                            backgroundColor:
                                                                "transparent !important",
                                                        },
                                                    },
                                                }}
                                                multiple
                                                disableClearable
                                                id="autocomplete-categories"
                                                options={[
                                                    {
                                                        id: "allCategories",
                                                        name: "SELECIONAR TODOS",
                                                    },
                                                    ...activeCategories,
                                                ]}
                                                value={selectedCategoryObjects}
                                                onChange={
                                                    handleChangeCategories
                                                }
                                                inputValue={inputValueCategory}
                                                onInputChange={
                                                    handleInputChangeCategory
                                                }
                                                getOptionLabel={(category) => {
                                                    if (
                                                        category.id ===
                                                        "allCategories"
                                                    ) {
                                                        return (
                                                            <span
                                                                style={{
                                                                    color: "#419392",
                                                                    fontWeight: 500,
                                                                }}
                                                            >
                                                                {category.name}
                                                            </span>
                                                        );
                                                    } else {
                                                        return category.name;
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="filled"
                                                        sx={{
                                                            "& .MuiFilledInput-root":
                                                                {
                                                                    backgroundColor:
                                                                        "transparent",
                                                                    border: "none",
                                                                    boxShadow:
                                                                        "none",
                                                                    "&:before":
                                                                        {
                                                                            borderBottom:
                                                                                "none",
                                                                            backgroundColor:
                                                                                "transparent",
                                                                        },
                                                                    "&:after": {
                                                                        borderBottom:
                                                                            "none",
                                                                        backgroundColor:
                                                                            "transparent",
                                                                    },
                                                                    "&:hover:before":
                                                                        {
                                                                            borderBottom:
                                                                                "none",
                                                                            backgroundColor:
                                                                                "transparent",
                                                                        },
                                                                },
                                                        }}
                                                    />
                                                )}
                                                renderTags={(
                                                    value,
                                                    getTagProps
                                                ) =>
                                                    value.map(
                                                        (option, index) => (
                                                            <Chip
                                                                key={option.id}
                                                                label={getCategoryName(
                                                                    option.id
                                                                )}
                                                                onDelete={() =>
                                                                    handleRemoveCategory(
                                                                        option
                                                                    )
                                                                }
                                                                {...getTagProps(
                                                                    { index }
                                                                )}
                                                            />
                                                        )
                                                    )
                                                }
                                                freeSolo
                                                ListboxProps={{
                                                    style: {
                                                        overflowY: "auto",
                                                        maxHeight: "220px",
                                                    },
                                                }}
                                            />
                                        </Box>
                                        <Button
                                            sx={{
                                                width: 110,
                                                fontSize: 12,
                                                padding: "10px 0px",
                                            }}
                                            variant={"text"}
                                            color={"error"}
                                            onClick={
                                                handleClearSelectedCategories
                                            }
                                        >
                                            REMOVER TUDO
                                        </Button>
                                    </FormControl>

                                </ModalLineView>
                                    <Box
                                        sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        width: "100%",
                                        backgroundColor: "#e2e2e2",
                                        padding: "14px",
                                        borderRadius: "8px",
                                        marginTop: "4px",
                                        fontSize: "13px",
                                        color: "grey",
                                        }}
                                    >
                                        <img
                                        src="/img/alert.svg"
                                        alt="alert"
                                        width={14}
                                        height={14}
                                        style={{ filter: "invert(0) brightness(0)" }} // 🔽 força preto
                                        />

                                        <p
                                        style={{
                                            color: "#2e2e2e",
                                            fontWeight: 600,
                                            textTransform: "uppercase",
                                            margin: 0,
                                        }}
                                        >
                                        Atenção: deixando os campos em branco, o usuário será
                                        cadastrado em todas as categorias e centros de custo.
                                        </p>
                                    </Box>
                                 </ModalLineView>
                            </>
                        )}
                    </ModalView>
                    <Clear />
                    <ModalFooter>
                        {type === "many" ? (
                            <Button
                                style={{
                                    fontSize: 12,
                                    padding: "8px 40px",
                                    opacity:
                                        fileFormatOk && users?.length > 0
                                            ? 1
                                            : 0.4,
                                }}
                                variant={
                                    fileFormatOk && users?.length > 0
                                        ? "contained"
                                        : "outlined"
                                }
                                color={
                                    fileFormatOk && users?.length > 0
                                        ? "primary"
                                        : "secondary"
                                }
                                onClick={
                                    fileFormatOk && users.length > 0
                                        ? handleNextStep
                                        : () => {}
                                }
                                disabled={
                                    nextLoading ||
                                    errorMessage !== "" ||
                                    isValidating ||
                                    isCheckingEmail
                                }
                            >
                                {step < 1 ? "PRÓXIMO" : "ENVIAR CONVITES"}
                            </Button>
                        ) : (
                            <Button
                                style={{
                                    fontSize: 12,
                                    padding: "8px 40px",
                                }}
                                variant="contained"
                                color="primary"
                                onClick={
                                    users.length > 0 ? handleNextStep : () => {}
                                }
                                disabled={
                                  nextLoading ||
                                  errorMessage !== "" ||
                                  isValidating ||
                                  isCheckingEmail ||
                                  name?.length < 3
                                    || !email ||
                                    !helper.validEmail(email)
                              }
                            >
                                {step < 1 ? "PRÓXIMO" : "ENVIAR CONVITES"}
                            </Button>
                        )}
                    </ModalFooter>
                </ModalCenter>
            </Modal>
            <ErrorModal
                open={errorModalOpen}
                onClose={() => setErrorModalOpen(false)}
                message={errorModalMessage}
            />
            <ModalUpgrade
                open={localUpgradeModalOpen}
                onClose={() => {
                    setLocalUpgradeModalOpen(false);
                    setLocalSuggestedPlan(null);
                }}
                suggestedPlan={localSuggestedPlan}
                currentPlanName={currentPlanName}
                activeUsersCount={activeUsersCount}
                impersonateCompanyId={impersonateCompanyId}
                onUpgradeSuccess={() => {
                    if (getUsers) {
                        getUsers("all", "all");
                    }
                }}
                showErrorModal={showErrorModal}
                showToastMessage={showToastMessage}
                zIndex={10000}
                setRefetchProfile={setRefetchProfile}
                companyCnpj={companyCnpj}
                acceptTermsOfUse={acceptTermsOfUse}
            />
            <ModalSpecialPlanOffer
                open={openUpgradeSpecialModal}
                onClose={() => setOpenUpgradeSpecialModal(false)}
                activeUsersCount={activeUsersCount}
                zIndex={10000}
            />
        </>
    );
}
